import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import './UserProfileAvatar.css';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      avatarColor: this.generateColorHSL()
    }

    this.handleClick = this.handleClick.bind(this);
  }

  generateColorHSL() {
    return 'hsl(' + Math.random() * 360 + ', 100%, 75%)';
  }

  avatarCharacter() {
    return this.props.name.charAt(0);
  }

  handleClick() {
    this.setState({
      avatarColor: this.generateColorHSL()
    });
  }

  inProgressAvatar() {
    return (
      <div className="avatar avatar--in-progress"
        style={{backgroundColor: this.state.avatarColor}}
        onClick={this.handleClick}>
        {this.avatarCharacter()}
      </div>
    );
  }

  readyAvatar() {
    return (
      <div className="avatar avatar--ready"
        style={{backgroundColor: this.state.avatarColor}}
        onClick={this.handleClick}>
        <div className="icon icon--check">
          <MaterialIcon icon="check" />
        </div>
        {this.avatarCharacter()}
      </div>
    );
  }

  showingAvatar() {
    return (
      <div className={`avatar avatar--showing avatar--${this.props.roomCurrentStepType}`}>
        {this.props.estimate}
      </div>
    );
  }

  render() {
    if (this.props.status === 'in-progress') {
      return ( this.inProgressAvatar() );
    } else if (this.props.status === 'ready' && !this.props.roomShowEstimate) {
      return ( this.readyAvatar() );
    } else if (this.props.status === 'ready' && this.props.roomShowEstimate) {
      return ( this.showingAvatar() );
    } else {
      return ( this.inProgressAvatar() );
    }
  }
}



// WEBPACK FOOTER //
// ./src/Room/UserProfileAvatar.js